import axios from 'axios';
import getWebchatUrl from '@/utils/getWebchatUrl';
export const mentionApi = (path = '', team = false) =>
  `${getWebchatUrl(window.location.href)}/api/${team ? 'team-mentions' : 'note-mentions'}${path}`;
export const mentionEvent = (team = false) =>
  team ? 'chekkit-team-mentions-changed' : 'chekkit-mentions-changed';
export const refreshMentions = (team = false) =>
  window.dispatchEvent(new Event(mentionEvent(team)));
export async function markMentionRead(id: string, team = false) {
  await axios.post(
    mentionApi(`/${encodeURIComponent(id)}/read`, team),
    {},
    { withCredentials: true },
  );
  refreshMentions(team);
}
